export default __webpack_public_path__ + "static/ebook-hand-f78458b4ad9c45ffd641d3f645a3e218.png";